import {Issue} from "../api/issue.ts";
import {DateTime} from "luxon";

const ordinal = (day: number): string => {
    if (day >= 11 && day <= 13) return `${day}th`;
    switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
    }
};

const formatDateCSV = (ms: number): string => {
    const dt = DateTime.fromMillis(ms);
    return `${ordinal(dt.day)} ${dt.toFormat('LLLL yyyy, HH:mm')}`;
};

const escapeCSV = (val: string) => `"${val.replace(/"/g, '""')}"`;

const downloadCSV = (csv: string, filename: string) => {
    const blob = new Blob([csv], {type: 'text/csv'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 100);
};

export const exportIssuesCSV = (issues: Issue[], siteName: string) => {
    const sorted = [...issues].sort((a, b) => b.createdAt - a.createdAt);

    const headers = ['Title', 'Description', 'Location', 'Priority', 'Category', 'Status', 'Opened', 'Completed'];
    const rows = sorted.map(issue => [
        issue.title,
        issue.description,
        issue.location,
        issue.priority.name,
        issue.category.name,
        issue.status,
        formatDateCSV(issue.createdAt),
        issue.closedAt ? formatDateCSV(issue.closedAt) : ''
    ]);

    const csv = [headers, ...rows].map(row => row.map(escapeCSV).join(',')).join('\n');
    const filename = `${siteName.toLowerCase().replace(/\s+/g, '-')}-issues.csv`;
    downloadCSV(csv, filename);
};
